import {
  HubResponsiveValue,
  HubStyleObject,
  StandardIconSizes,
} from '@hub/design-system-base'
import React from 'react'
import { DirectLogo } from './direct-logo'
import { WestfieldLogo } from './westfield-logo'
import { WestfieldPlusLogo } from './westfield-plus-logo'

interface LogoProps {
  variant?: 'direct' | 'westfield' | 'westfield-plus'
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
  mono?: boolean
  label?: string
}

export const Logo: React.FC<LogoProps> = ({
  variant,
  mono = false,
  boxSize,
  sx,
  label,
}) => {
  switch (variant) {
    case 'direct':
      return <DirectLogo mono={mono} sx={sx} boxSize={boxSize} label={label} />

    case 'westfield-plus':
      return <WestfieldPlusLogo sx={sx} boxSize={boxSize} label={label} />

    case 'westfield':
      return <WestfieldLogo sx={sx} boxSize={boxSize} label={label} />

    default:
      return <WestfieldLogo sx={sx} boxSize={boxSize} label={label} />
  }
}
